import React from 'react';
import { useTranslation } from '../i18n';
import NavItem from './NavItem';
import BottomNavItem from './BottomNavItem';

export default function AppShell({ children, chatInput, onContactClick, viewMode, onViewModeChange, showRoteiroButton }) {
  const { t } = useTranslation();
  return (
    <>
      <nav className="top-nav">
        <h1 className="top-nav-title">{t('app.name')}</h1>
        <div className="top-nav-actions">
          {showRoteiroButton && (
            <button
              type="button"
              className={`top-nav-btn ${viewMode === 'roteiro' ? 'top-nav-btn--active' : ''}`}
              onClick={() => onViewModeChange && onViewModeChange('roteiro')}
              title={t('nav.roteiro')}
            >
              <span className="material-symbols-outlined">map</span>
            </button>
          )}
          <button
            type="button"
            className={`top-nav-btn ${viewMode === 'exploration' ? 'top-nav-btn--active' : ''}`}
            onClick={() => onViewModeChange && onViewModeChange('exploration')}
            title={t('nav.exploration')}
          >
            <span className="material-symbols-outlined">explore</span>
          </button>
          <button
            type="button"
            className={`top-nav-btn ${viewMode === 'chat' ? 'top-nav-btn--active' : ''}`}
            onClick={() => onViewModeChange && onViewModeChange('chat')}
            title={t('nav.chat')}
          >
            <span className="material-symbols-outlined">chat</span>
          </button>
        </div>
      </nav>

      <aside className="side-nav">
        <div className="side-nav-brand">
          <h1>{t('app.name')}</h1>
          <p>{t('app.tagline')}</p>
        </div>
        <nav className="side-nav-links">
          <NavItem 
            icon="chat" 
            label={t('nav.chat')} 
            active={viewMode === 'chat'} 
            onClick={() => onViewModeChange && onViewModeChange('chat')}
          />
          <NavItem 
            icon="explore" 
            label={t('nav.exploration')} 
            active={viewMode === 'exploration'} 
            onClick={() => onViewModeChange && onViewModeChange('exploration')}
          />
          <NavItem 
            icon="map" 
            label={t('nav.roteiro')} 
            active={viewMode === 'roteiro'}
            disabled={!showRoteiroButton}
            onClick={() => showRoteiroButton && onViewModeChange && onViewModeChange('roteiro')}
          />
          <NavItem icon="confirmation_number" label={t('nav.bookings')} disabled />
          <NavItem icon="bookmark" label={t('nav.saved')} disabled />
        </nav>
        <div className="side-nav-footer">
          <NavItem icon="coffee" label={t('nav.buyCoffee')} onClick={() => window.open('https://buymeacoffee.com/igorhborges', '_blank', 'noopener')} />
          <NavItem icon="feedback" label={t('nav.contact')} onClick={onContactClick} />
        </div>
      </aside>

      <main className="main-content">
        {children}
        {chatInput}
      </main>

      <aside className="trip-sidebar">
        <div>
          <div className="trip-sidebar-header">
            <h2>{t('trip.current')}</h2>
            <button type="button" className="trip-sidebar-edit" onClick={(e) => e.preventDefault()}>{t('trip.edit')}</button>
          </div>
          <div className="trip-card">
            <img
              src="https://images.unsplash.com/photo-1534113414500-0a0a0a0a0a0a?w=640&h=320&fit=crop"
              alt={t('trip.current')}
            />
            <div className="trip-card-overlay">
              <div>
                <p className="trip-card-dates">{t('trip.sampleDates')}</p>
                <p className="trip-card-location">{t('trip.sampleLocation')}</p>
              </div>
            </div>
          </div>
          <div className="trip-stats">
            <div className="trip-stat">
              <p className="trip-stat-label">{t('trip.flights')}</p>
              <p className="trip-stat-value">{t('trip.pending')}</p>
            </div>
            <div className="trip-stat">
              <p className="trip-stat-label">{t('trip.hotels')}</p>
              <p className="trip-stat-value">{t('trip.oneSelected')}</p>
            </div>
          </div>
          <p className="trip-draft-label">{t('trip.draftLabel')}</p>
          <div className="trip-draft-item">
            <div className="trip-draft-icon">
              <span className="material-symbols-outlined">hotel</span>
            </div>
            <div className="trip-draft-info">
              <p className="trip-draft-name">{t('trip.draftHotelName')}</p>
              <p className="trip-draft-sub">{t('trip.draftHotelLocation')}</p>
            </div>
          </div>
          <div className="trip-draft-item">
            <div className="trip-draft-icon">
              <span className="material-symbols-outlined">restaurant</span>
            </div>
            <div className="trip-draft-info">
              <p className="trip-draft-name">{t('trip.draftRestaurantName')}</p>
              <p className="trip-draft-sub">{t('trip.draftRestaurantDesc')}</p>
            </div>
          </div>
        </div>
        <div className="trip-documents">
          <div className="trip-documents-header">
            <span className="material-symbols-outlined">description</span>
            <span>{t('trip.documents')}</span>
          </div>
          <button type="button" className="trip-upload-btn" onClick={(e) => e.preventDefault()}>
            {t('trip.uploadPassport')}
          </button>
        </div>
      </aside>

      <nav className="bottom-nav">
        {showRoteiroButton && (
          <BottomNavItem 
            icon="map" 
            label={t('nav.roteiro')} 
            active={viewMode === 'roteiro'} 
            onClick={() => onViewModeChange && onViewModeChange('roteiro')} 
          />
        )}
        <BottomNavItem icon="coffee" label={t('nav.buyCoffee')} onClick={() => window.open('https://buymeacoffee.com/igorhborges', '_blank', 'noopener')} />
        <BottomNavItem icon="feedback" label={t('nav.contact')} onClick={onContactClick} />
      </nav>
    </>
  );
}
